import { useCallback, useMemo } from 'react';
import {
  useReduceWithModel,
  IModel,
} from '@/hooks/useReduceWithModel/useReduceWithModel';

interface IState {
  // 氛围页广告是否滚动
  autoplay: boolean;
  selectedIndex: number;
}

const initialState: IState = {
  autoplay: true,
  selectedIndex: 0,
};

/**
 * 可以直接返回state，也可以修改draft里面的数据，返回空
 * @param draft
 * @param action
 */

enum actionEnum {
  autoplay = 'autoplay',
  selectedIndex = 'selectedIndex',
}

const model: IModel<IState> = {
  immer: true,
  state: initialState,
  reducers: {
    [actionEnum.autoplay](
      state: IState,
      action: {
        type: actionEnum;
        [extraProps: string]: any;
      },
    ) {
      return {
        ...state,
        autoplay: action.payload,
      };
    },
    [actionEnum.selectedIndex](
      state: IState,
      action: {
        type: actionEnum;
        [extraProps: string]: any;
      },
    ) {
      return {
        ...state,
        selectedIndex: action.payload,
      };
    },
  },
};

const useAtmosphereDetailsModel = () => {
  const [state, dispatch] = useReduceWithModel(model);

  const setAutoplay = useCallback(
    (payload: boolean) => {
      dispatch({
        type: actionEnum.autoplay,
        payload,
      });
    },
    [dispatch],
  );

  const setSelectedIndex = useCallback(
    (payload: number) => {
      dispatch({
        type: actionEnum.selectedIndex,
        payload,
      });
    },
    [dispatch],
  );

  const autoplay = useMemo(() => state.autoplay, [state]);
  const selectedIndex = useMemo(() => state.selectedIndex, [state]);

  return {
    state,
    autoplay,
    selectedIndex,
    setAutoplay,
    setSelectedIndex,
  };
};

export default useAtmosphereDetailsModel;
